$(document).ready(function () {

    $(".hamburger").click(function () {
        $(this).toggleClass("is-active");
        $('.menu-header-mobile').toggleClass('open')
    });

    $('.has-submenu').on('click', function () {
        $('.submenu', this).slideToggle(300)
    })

    $(window).on("scroll", function () {
        $("body").toggleClass("down", ($(window).scrollTop() > 180));
    });

    if ($('body').hasClass('has-loading')) {
        // $('body').addClass('overflow-hidden')
        $('.loading-container svg').css('opacity', 1);
        setTimeout(() => {
            $('.loading-container img').css('opacity', 1);
        }, 600);
        setTimeout(() => {
            $('.loading-container img').fadeOut(500);
            $('.loading-container svg').fadeOut(500);
            $('.loading-container').delay(500).fadeOut(1000);
            // $('body').removeClass('overflow-hidden');
            setTimeout(() => {
                AOS.init({
                    duration: 1500, // values from 0 to 3000, with step 50ms
                    easing: 'ease', // default easing for AOS animations
                });
            }, 200);

        }, 1200);
    } else {
        AOS.init({
            duration: 1500, // values from 0 to 3000, with step 50ms
            easing: 'ease', // default easing for AOS animations
        });
    }


    var sliderSwiper = new Swiper(".sliderSwiper", {
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    var featuredSwiper = new Swiper(".featuredSwiper", {
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

  
    var productSwiper = new Swiper(".productSwiper", {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        // pagination: {
        //     el: ".swiper-pagination",
        //     type: "fraction",
        // },
      navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // navigation: {
        //     nextEl: '.product-swiper-button-next',
        //     prevEl: '.product-swiper-button-prev',
        // },
        breakpoints: {
            0: {
                slidesPerView: 2,
                pagination: false
            },
            768: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        },
    });

    var colSwiper = new Swiper(".colSwiper", {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        // pagination: {
        //     el: ".swiper-pagination",
        //     type: "fraction",
        // },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                pagination: false
            },
            768: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            },
        },
    });
  
   var blogSwiper = new Swiper(".blogSwiper", {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        // pagination: {
        //     el: ".swiper-pagination",
        //     type: "fraction",
        // },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                pagination: false
            },
            768: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            },
        },
    });
  
    var testiSwiper = new Swiper(".testiSwiper", {
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
  
    var mySwiper = new Swiper(".mySwiper", {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
      });
      var mySwiper2 = new Swiper(".mySwiper2", {
        loop: true,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: mySwiper,
        },
      });
    

    var $val1 = '';
    var $val2 = '';
    $('.quiz-answer').on('change', function () {
        $val1 = $(this).val();
        if ($.inArray($val1, ['A', 'B', 'C']) != -1) {
            $('.quiz').hide();
            $('.quiz-02').fadeIn();
        } else if ($val1 === 'D') {
            $('.quiz').hide();
            $('.quiz-03').fadeIn();
        } else {
            $('.quiz').hide();
            $('.quiz-04').fadeIn();
        }
    });
    $('.quiz-answer-02').on('change', function () {
        $val2 = $(this).val();
        if ($val1 === 'A' && $val2 === '2') {
            // Seg 1
            $('.quiz').hide();
            $('.quiz-result').hide();
            $('.quiz-result-01').fadeIn();
        }
        if ($.inArray($val1, ['B', 'C']) != -1 && $val2 === '2') {
            // Seg 2
            $('.quiz').hide();
            $('.quiz-result').hide();
            $('.quiz-result-02').fadeIn();
        }
        if ($.inArray($val1, ['A', 'B', 'C']) != -1 && $val2 === '1') {
            // Seg 3
            $('.quiz').hide();
            $('.quiz-result').hide();
            $('.quiz-result-03').fadeIn();
        }
        if ($val1 === 'D') {
            // Seg 4
            $('.quiz').hide();
            $('.quiz-result').hide();
            $('.quiz-result-04').fadeIn();
        }
        if ($val1 === 'E') {
            // Seg 5
            $('.quiz').hide();
            $('.quiz-result').hide();
            $('.quiz-result-05').fadeIn();
        }

    });
})